import { Carousel, Spin } from "antd";
import { useEffect, useState } from "react";
import { GET } from "../../utils/apicalls";
import { API } from "../../config/api";
import "./homepagebanner.css";


function Homepagebanner() {
  const [bannerdata, setbannerdata] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchBanner = async () => {
    try {
      setIsLoading(true);
      const response: any = await GET(API.BANNER_MANAGEMENT, {});
      setbannerdata(response?.data || []);
    } catch (error) {
      console.error("Error fetching banner data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchBanner();
  }, []);

  if (isLoading) {
    return (
      <div className="loading-container">
        <Spin size="large" />
      </div>
    );
  }

  if (!bannerdata || bannerdata.length === 0) {
    return <div className="no-banner">No banner data available</div>;
  }

  return (
    <div className="banner-container">
      <Carousel autoplay autoplaySpeed={4000} arrows={true} className="custom-carousel-unique">
        {bannerdata.map((banner: any, index: number) => (
          <div key={index} className="banner-slide">
            <div
              className="banner-image"
              style={{ backgroundImage: `url(${banner.bannerImage})` }}
            >
              <div className="overlay">
                <div className="banner-text">
                  <h3 className="banner-h3">{banner.bannerTitle_two}</h3>
                  <h1 className="banner-h1">{banner.bannerTitle_one?.toUpperCase()}</h1>
                  <p className="banner-p">{banner.bannerSubHeading}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Carousel>
    </div>
  );
}

export default Homepagebanner;